/**
 * Edge configuration for the IVR Journey diagram.
 * BR-14: Edge Design specification
 */

import { MarkerType } from 'reactflow';

export const defaultEdgeOptions = {
  type: 'smoothstep',
  animated: false,
  style: {
    stroke: '#CBD5E1',
    strokeWidth: 1.5,
  },
  markerEnd: {
    type: MarkerType.ArrowClosed,
    color: '#CBD5E1',
    width: 16,
    height: 16,
  },
};
